export const ITEM_FUNCTION_TPYE = {
  DEFAULT: 'default',
  STATUS: 'status',
  USERGIFT: 'usergift',
  MYROOM: 'myroom',
  SKILL: 'skill', // 스킬
  EQUIPMENT: 'equipment', // 장비
  PET: 'pet',
  BETTING_CREATE: 'betting_create', // 베팅 주제 만들기
  QUEST_CREATE: 'quest_create', // 퀘스트 만들기
  RANDOM_BOX: 'random_box', // 랜덤박스 (사용 시 오픈)
  RANDOM_BOX_POST: 'random_box_post', // 랜덤박스 (게시글 업로드 시 오픈)
  INVESTIGATION: 'investigation', // 조사 지문
} as const;

export type ITEM_FUNCTION_TPYE_KEY = keyof typeof ITEM_FUNCTION_TPYE;

export type ITEM_FUNCTION_TPYE_VALUE =
  typeof ITEM_FUNCTION_TPYE[ITEM_FUNCTION_TPYE_KEY];

// 🐾 펫 전용 서브 기능 타입 정의
export const PET_SUB_FUNCTION_TYPE = {
  FILL_HUNGER: 'fill_hunger',
  FILL_EXP: 'fill_exp',
  CHANGE_NAME: 'change_name',
  CHANGE_APPEARANCE: 'change_appearance',
  CHANGE_BACKGROUND: 'change_background',
} as const;

export type PET_SUB_FUNCTION_TYPE_KEY = keyof typeof PET_SUB_FUNCTION_TYPE;

export type PET_SUB_FUNCTION_TYPE_VALUE =
  typeof PET_SUB_FUNCTION_TYPE[PET_SUB_FUNCTION_TYPE_KEY];

export const ITEM_FUNCTION_TPYE_MAP = {
  [ITEM_FUNCTION_TPYE.DEFAULT]: '기본',
  [ITEM_FUNCTION_TPYE.STATUS]: '스탯 보정',
  [ITEM_FUNCTION_TPYE.USERGIFT]: '유저 아이템 등록',
  [ITEM_FUNCTION_TPYE.MYROOM]: '마이룸 꾸미기용',
  [ITEM_FUNCTION_TPYE.PET]: '펫 전용',
  [ITEM_FUNCTION_TPYE.BETTING_CREATE]: '베팅 주제 만들기',
  [ITEM_FUNCTION_TPYE.QUEST_CREATE]: '퀘스트 만들기',
  [ITEM_FUNCTION_TPYE.RANDOM_BOX]: '랜덤박스 (사용 시)',
  [ITEM_FUNCTION_TPYE.RANDOM_BOX_POST]: '랜덤박스 (게시글 업로드 시)',
  [ITEM_FUNCTION_TPYE.EQUIPMENT]: '장비',
  [ITEM_FUNCTION_TPYE.SKILL]: '스킬',
  [ITEM_FUNCTION_TPYE.INVESTIGATION]: '조사 지문',
};

// 🐾 펫 서브 기능 매핑
export const PET_SUB_FUNCTION_TYPE_MAP = {
  [PET_SUB_FUNCTION_TYPE.FILL_HUNGER]: '배고픔 채우기',
  [PET_SUB_FUNCTION_TYPE.FILL_EXP]: '경험치 채우기',
  [PET_SUB_FUNCTION_TYPE.CHANGE_NAME]: '펫 이름 바꾸기',
  [PET_SUB_FUNCTION_TYPE.CHANGE_APPEARANCE]: '펫 외관 바꾸기',
  [PET_SUB_FUNCTION_TYPE.CHANGE_BACKGROUND]: '펫 배경 바꾸기',
};

// 아이템 속성 선택 UI에서 임시 숨김 처리할 타입
const HIDDEN_ITEM_FUNCTION_TYPES = new Set<string>([
  ITEM_FUNCTION_TPYE.RANDOM_BOX,
  ITEM_FUNCTION_TPYE.RANDOM_BOX_POST,
  ITEM_FUNCTION_TPYE.EQUIPMENT,
  ITEM_FUNCTION_TPYE.SKILL,
  ITEM_FUNCTION_TPYE.INVESTIGATION,
]);

export const itemFunctionTypeList = Object.keys(ITEM_FUNCTION_TPYE_MAP)
  .filter((key) => !HIDDEN_ITEM_FUNCTION_TYPES.has(key))
  .map((key) => ({
    key,
    value: ITEM_FUNCTION_TPYE_MAP[key],
  }));

// 🐾 펫 서브 기능 리스트
export const petSubFunctionTypeList = Object.keys(PET_SUB_FUNCTION_TYPE_MAP).map(
  (key) => {
    return {
      key: key,
      value: PET_SUB_FUNCTION_TYPE_MAP[key],
      hasValue: key === PET_SUB_FUNCTION_TYPE.FILL_HUNGER || key === PET_SUB_FUNCTION_TYPE.FILL_EXP, // 수치 입력이 필요한지 여부
    };
  },
);

// ❤️ HP/MP 전용 서브 기능 타입 (스탯 보정 아이템 중 hp/mp 선택 시)
export const STATUS_SUB_FUNCTION_TYPE = {
  ADD_MAX: 'add_max',           // 최대값 증가 (피통/마통 증가)
  RESTORE_CURRENT: 'restore_current', // 현재값 회복 (HP/MP 포션)
} as const;

export type STATUS_SUB_FUNCTION_TYPE_KEY = keyof typeof STATUS_SUB_FUNCTION_TYPE;
export type STATUS_SUB_FUNCTION_TYPE_VALUE = typeof STATUS_SUB_FUNCTION_TYPE[STATUS_SUB_FUNCTION_TYPE_KEY];

export const STATUS_SUB_FUNCTION_TYPE_MAP = {
  [STATUS_SUB_FUNCTION_TYPE.ADD_MAX]: '최대값 증가 (피통/마통)',
  [STATUS_SUB_FUNCTION_TYPE.RESTORE_CURRENT]: '현재값 회복 (포션)',
};

export const statusSubFunctionTypeList = Object.keys(STATUS_SUB_FUNCTION_TYPE_MAP).map(
  (key) => ({
    key,
    value: STATUS_SUB_FUNCTION_TYPE_MAP[key as STATUS_SUB_FUNCTION_TYPE_VALUE],
  }),
);
